import React from "react";

export default function EmptyList({
  description,
  title,
  image,
}: {
  description?: string;
  title?: string;
  image?: string;
}) {
  return (
    <div className=" border-[px] border-#C8CCC8] rounded-lg py-10   min-h-[280px]  w-full ">
      <div className="flex flex-col text-center justify-center items-center gap-3 ">
        <img
          src={image ? image : "/img/notFound.jpg"}
          alt=""
          height={250}
          width={250}
        />
        {title && <p className=" text-[18px] font-bold ">{title}</p>}
        {description && <p className=" text-sm ">{description}</p>}
      </div>
    </div>
  );
}
